// const MOCK_DEV_SERVER_API = DEV_SERVER_API;

// const DEV_SERVER_API = '//localhost:50290/api';

// const DEV_SERVER_API = '//SYDDC1DEVTST1V:3000/api';

const LEGACY_SERVER_API = {
  DEV: 'https://gateway.eclipx.xyz/nitro-legacy/dev/api',
  UAT: 'https://gateway.eclipx.xyz/nitro-legacy/uat/api',
  PROD: 'https://gateway.eclipx.com/nitro-legacy/prod/api',
  AUBAU: 'https://gateway.eclipx.xyz/nitro-legacy/aubau/api'
};
// const DEV_SERVER_API = '//MELDC1APIPRD3V:3000/api';

// Local testing in mobile devices
// const DEV_SERVER_API = '//10.88.1.106:3000/api'
/**
 * Calls to the API use a reverse proxy which means posts from the client side
 * can now use the following route https://<DNS>/api/…
 * This should fix the SSL issues we’ve run into.
 * e.g https://portal-dev.fleetpartners.com.au/api/getView
 *
 * any calls from localhost should still use the DEV_SERVER_API, as that
 * allows CORS
 */
export const getAPIRoot = config => {
  const { host } = location;
  if (host.toLowerCase().includes('dev') || host.toLowerCase().includes('localhost')) {
    return LEGACY_SERVER_API.DEV
  } else if (host.toLowerCase().includes('uat')) {
    return LEGACY_SERVER_API.UAT
  } else if (host.toLowerCase().includes('bau')) {
    return LEGACY_SERVER_API.AUBAU
  }
  return LEGACY_SERVER_API.PROD
};

export const getAdminAPIRoot = config => getAPIRoot();
// 'https://295e9a75-cb84-4f09-9ebd-f132d1f91582.mock.pstmn.io/api';

// GetView + Auth
export const CONFIG_GET_VIEW = `${getAPIRoot()}/home/getView`;
export const AUTH_GET_TOKEN = `${getAPIRoot()}/token`;

// Account
export const ACCEPT_TERMS = `${getAPIRoot()}/Account/AcceptTerms`;

//
export const API_ROOT = `${getAPIRoot()}/`;
// Fbt
export const FBT_DRIVER_INFO = `${getAPIRoot()}/fleet/fbt/GetCurrentPeriodInfo`;
export const FBT_SUMMARY = `${getAPIRoot()}/fleet/fbt/summary`;
export const FBT_CURRENT_EXEMPTIONS = `${getAPIRoot()}/fleet/fbt/GetCurrentExemptions`;
export const FBT_SAVE_EXEMPTION = `${getAPIRoot()}/fleet/fbt/saveExemption`;
export const FBT_REMOVE_EXEMPTION = `${getAPIRoot()}/fleet/fbt/removeExemption`;
export const FBT_UPDATE_EXEMPTION = `${getAPIRoot()}/fleet/fbt/updateExemption`;
export const FBT_EXEMPTION_TYPES = `${getAPIRoot()}/fleet/fbt/getExemptionTypes`;
export const FBT_SUBMIT_EXEMPTIONS = `${getAPIRoot()}/fleet/fbt/submitExemption`;
export const FBT_LEASE_INFO = `${getAPIRoot()}/fleet/fbt/:id/details`;
export const FBT_REPORT_PERIODS = `${getAPIRoot()}/fleet/fbt/reporting-periods`;

// Contribution Documents
export const FBT_DELETE_CONTRIBUTION_DOCUMENT = `${getAPIRoot()}/fleet/fbt/contributions/:contribid/documents/:docid`;
export const FBT_ADD_CONTRIBUTION_DOCUMENT = `${getAPIRoot()}/fleet/fbt/contributions/:contribid/documents`;

export const FBT_SUBMIT_CONTRIBUTION = `${getAPIRoot()}/fleet/fbt/contributions`;
export const FBT_FETCH_CONTRIBUTION = `${getAPIRoot()}/fleet/fbt/:id/contributions`;
export const FBT_REMOVE_CONTRIBUTION = `${getAPIRoot()}/fleet/fbt/contributions/:id`;
export const FBT_FETCH_EXCEMPTIONS = `${getAPIRoot()}/fleet/fbt/:id/exemptions`;
export const FBT_FETCH_VEHICLE = `${getAPIRoot()}/fleet/fbt/:id/vehicle`;

// Change Password
export const Forgot_Password = `${getAPIRoot()}/account/ForgotPassword`;
export const Reset_Password = `${getAPIRoot()}/account/ResetPassword`;
export const Validate_Reset_Token = `${getAPIRoot()}/account/ValidateResetToken`;
export const LOGOUT_EXPIRE_TOKEN = `${getAPIRoot()}/account/logout`;

// Profile
export const PROFILE_INFO = `${getAPIRoot()}/Account/ProfileInfo`;
export const PROFILE_CHANGE_PASSWORD = `${getAPIRoot()}/Account/ChangePassword`;

// Corporate Quote
export const CORPORATE_QUOTE_QUESTIONS = `${getAPIRoot()}/fleet/corporateQuote/getQuestions`;
export const CORPORATE_QUOTE_VEHICLES = `${getAPIRoot()}/fleet/corporateQuote/getVariants`;
export const CORPORATE_QUOTE_SUMMARY = `${getAPIRoot()}/fleet/corporatequote/getQuoteSummary`;
export const CORPORATE_QUOTE_SUMMARY_APPROVAL = `${getAPIRoot()}/fleet/corporatequote/getQuoteSummaryForApproval`;

export const CORPORATE_QUOTE_EXPORT = `${getAPIRoot()}/fleet/corporatequote/exportQuote`;
export const CORPORATE_QUOTE_SUBMIT = `${getAPIRoot()}/fleet/corporatequote/submitQuote`;
export const CORPORATE_QUOTE_UPDATE = `${getAPIRoot()}/fleet/corporatequote/updateQuote`;

export const CORPORATE_QUOTE_APPROVE = `${getAPIRoot()}/fleet/corporatequote/approveQuote`;
export const CORPORATE_QUOTE_DECLINE = `${getAPIRoot()}/fleet/corporatequote/declineQuote`;

// TODO make getVehicleOptions call dynamic from selectedVehicle
export const CORPORATE_QUOTE_OPTIONS = `${getAPIRoot()}/fleet/corporatequote/getVehicleOptions`;

// this is not a corporare quote endpoint....
export const CORPORATE_QUOTE_GET_ADDRESSES = `${getAPIRoot()}/geocode/getAddress`;

export const CORPORATE_QUOTE_GET_APPROVALS = `${getAPIRoot()}/fleet/corporatequote/getApprovalSummary`;
export const CORPORATE_QUOTE_GET_USER_QUOTES = `${getAPIRoot()}/fleet/corporatequote/getQuotes`;
export const CORPORATE_QUOTE_SEND_EMAIL = `${getAPIRoot()}/fleet/corporatequote/resendEmail`;
export const CORPORATE_QUOTE_WORKFLOW_SETUP_LIST = `${getAPIRoot()}/admin/corporatequote/workflows`;
export const CORPORATE_QUOTE_WORKFLOW_SETUP_ASSIGNEE = `${getAPIRoot()}/admin/corporatequote/assignee`;
export const CORPORATE_QUOTE_WORKFLOW_SETUP_APPROVER = `${getAPIRoot()}/admin/corporatequote/approvers`;
export const CORPORATE_QUOTE_WORKFLOW_SETUP_WORKFLOW = `${getAPIRoot()}/admin/corporatequote/workflows`;

// Insights
export const INSIGHT_TILE_DATA = `${getAPIRoot()}/insight/getTileData/`; // {tileId}
export const INSIGHT_GRAPH_DATA = `${getAPIRoot()}/insight/getGraphData/`; // {tileId}
export const INSIGHT_EXPORT_GRAPH_DATA = `${getAPIRoot()}/insight/exportGraphDetail/`;
export const INSIGHT_CHART = `${getAPIRoot()}/insight/getGraphData/`; // {graphId}
export const INSIGHT_GRAPH_DETAIL = `${getAPIRoot()}/insight/getGraphDetail/`; // {graphId, companyCode}
export const INSIGHT_NOTIFICATION_DETAIL = `${getAPIRoot()}/insight/getNotificationDetail`; // {graphId, companyCode}
export const INSIGHT_SUMMARY_DETAIL = `${getAPIRoot()}/insight/getSummaryData/`;
export const INSIGHT_TOTAL_TILL_DATE = `${getAPIRoot()}/insight/getTotalTillDateByKey`; // {driverId}
export const INSIGHTS_GRAPH_FILTER = `${getAPIRoot()}/insight/getMetadata`;
export const INSIGHT_EXPORT_PDF_IMAGE = `${getAPIRoot()}/images/export/`;
export const INSIGHT_SEND_GET_TELEMATICS_EMAIL = `${getAPIRoot()}/insight/SendGetTelematicsEmail/`;
export const INSIGHT_FBTSUMMARY_REPORT = `${getAPIRoot()}/insight/getFBTSubmissionSummaryTileData/report/`;

export const RELOCATION_VEHICLES = `${getAPIRoot()}/fleet/vehicles`;
export const RELOCATION_VEHICLE_DETAILS = `${getAPIRoot()}/fleet/vehicles/costcentres`;
export const RELOCATION_VEHICLES_CHANGE = `${getAPIRoot()}/fleet/vehicles/transfer/costCentre`;
export const RELOCATION_VEHICLE_AVAILABLE_CC = `${getAPIRoot()}/fleet/vehicles/transfercostcentres`;

// Driver Reallocation
export const REALLOCATION_DRIVER_ALLOCATION_DETAILS = `${getAPIRoot()}/fleet/vehicles/drivers`;
export const REALLOCATION_DRIVER_DETAILS = `${getAPIRoot()}/fleet/drivers`;
export const REALLOCATE_EXISTING_DRIVER = `${getAPIRoot()}/fleet/vehicles/transfer/driver`;
export const REALLOCATE_NEW_DRIVER = `${getAPIRoot()}/fleet/vehicles/transfer/driver/new`;

// Time Zones
export const TIME_ZONES = `${getAPIRoot()}/timezone/:country`;

// User Profile
export const USER_PROFILE = `${getAPIRoot()}/user`;

// User Admin new
export const USERS_ADMIN = `${getAdminAPIRoot()}/admin/users`;
export const USERS = USERS_ADMIN;
export const ADMIN = `${getAdminAPIRoot()}/admin`;
export const ROLES_ADMIN = `${getAdminAPIRoot()}/admin/roles`;
export const ROLES = `${getAdminAPIRoot()}/admin/roles`;
export const ROLE = `${getAdminAPIRoot()}/admin/roles`;

export const USER_ROLES_ADMIN = `${getAdminAPIRoot()}/admin/roles`;
export const CONTENTS_ADMIN = `${getAdminAPIRoot()}/admin/contents`;
export const CONTENTS = `${getAdminAPIRoot()}/contents`;
export const CONTENT = `${getAdminAPIRoot()}/contents`;

export const BUSINESS_ENTITIES_ADMIN = `${getAdminAPIRoot()}/admin/businessentity`;
export const ALL_RESTRICTIONS_ADMIN = `${getAdminAPIRoot()}/admin/users/getallrestrictions/:businessEntityId/:country/:companycode`;

// export const BUSINESS_ENTITIES = `${getAdminAPIRoot()}/businessEntities`;
// export const BUSINESSENTITIES = BUSINESS_ENTITIES;
export const BUSINESS_ENTITIES_ADMIN_CLAIMS = `${BUSINESS_ENTITIES_ADMIN}/claims`;
export const BUSINESS_ENTITIES_ADMIN_CLAIMS_BYUSER = `${ADMIN}/users/:id/claims`;
export const BUSINESS_ENTITIES = `${getAPIRoot()}/businessEntities`;
export const BUSINESSENTITIES = BUSINESS_ENTITIES_ADMIN;

// Company Hierarchy
export const COMPANY_HIERARCHY = `${getAPIRoot()}/admin/businessEntity/:businessEntityId/:countryCode/companyCodeHierarchy`;

// Costcentres
export const COST_CENTRE = `${BUSINESS_ENTITIES}/getChildCostCentersFor/:country/:costcentre`;
export const COMPANY_RESTRICTION = `${BUSINESS_ENTITIES}/restrictions/:country`;
export const ALL_RESTRICTIONS = `${USERS}/getallrestrictions/:country/:companycode`;

// Reports
export const REPORTS = `${getAPIRoot()}/reports`;
export const REPORTS_EXPORT = `${getAPIRoot()}/reports/export`;
export const REPORTS_CLONE = `${getAPIRoot()}/reports/clone`;

// Notification settings
export const NOTIFICATION_SETTINGS = `${getAPIRoot()}/account/notifications`;
export const NOTIFICATION_DELETE = `${getAPIRoot()}/notifications/changeStatus`;
export const GET_NOTIFICATIONS = `${getAPIRoot()}/notifications`;

// Demo
export const REQUEST_DEMO = `${getAPIRoot()}/demo/request`;

// Global search
export const SEARCH_HISTORY = `${getAPIRoot()}/Account/history/search`;
export const DRIVER_SEARCH = `${getAPIRoot()}/fleet/drivers/search`;
export const VEHICLE_SEARCH = `${getAPIRoot()}/fleet/vehicles/search`;

// Dashboard
export const DRIVER_PROFILE = `${getAPIRoot()}/fleet/drivers/profile`;
export const VEHICLE_PROFILE = `${getAPIRoot()}/fleet/vehicles/profile`;

export const DRIVER_DASHBOARD_REPORT_TILE = `${getAPIRoot()}/fleet/drivers/profile/getReportSummary`;
export const VEHICLE_DASHBOARD_REPORT_TILE = `${getAPIRoot()}/fleet/vehicles/profile/getInfoSummary`;
export const DRIVER_DASHBOARD_REPORT_DETAIL = `${getAPIRoot()}/fleet/drivers/profile/getReportDetail`;
export const DRIVER_DASHBOARD_CARD_DETAIL = `${getAPIRoot()}/fleet/drivers/profile/getCardDetail`;
export const DRIVER_DASHBOARD_CARD_SUMMARY = `${getAPIRoot()}/fleet/drivers/profile/getCardSummary`;
export const DRIVER_DASHBOARD_VEHICLE_SUMMARY = `${getAPIRoot()}/fleet/drivers/profile/getVehicleSummary`;
export const DRIVER_DASHBOARD_VEHICLE_HISTORY = `${getAPIRoot()}/fleet/vehicles/profile/history`;
export const VEHICLE_DASHBOARD_DRIVER_SUMMARY = `${getAPIRoot()}/fleet/vehicles/profile/getDriverSummary`;
export const VEHICLE_DASHBOARD_INFO_DETAIL = `${getAPIRoot()}/fleet/vehicles/profile/getInfoDetail`;
export const DRIVER_NOTES = `${getAPIRoot()}/fleet/drivers/profile/note`;

export const VEHICLE_NOTES = `${getAPIRoot()}/fleet/vehicles/profile/note`;

// Bookmarks
export const BOOKMARKS_DRIVER = `${getAPIRoot()}/fleet/drivers/profile/bookmark`;
export const BOOKMARKS_VEHICLE = `${getAPIRoot()}/fleet/vehicles/profile/bookmark`;

// Yellowfin
export const YELLOWFIN_SSO = `${getAPIRoot()}/yellowfin/sso`;
// servicenow
export const SERVICENOW_SUBMIT_INTEREST = `${getAPIRoot()}/servicenow/submitInterest`;
export const SERVICENOW_SSO = `${getAPIRoot()}/servicenow/sso`;

// Documents
export const DOCUMENT_ADD = `${getAPIRoot()}/userdocuments`;
export const DOCUMENT_DELETE = `${getAPIRoot()}/userdocuments/:docid`;
export const SERVICENOW_OUR_SERVICES =
  'https://1800accident.com.au/our-services/';
export const SEARCHRESULT = `${getAPIRoot()}/search/result`;



// WEBPACK FOOTER //
// ./src/api/const.js